import { render } from "./events-carousel.vue?vue&type=template&id=29fa1b59&scoped=true"
import script from "./events-carousel.vue?vue&type=script&lang=js"
export * from "./events-carousel.vue?vue&type=script&lang=js"

import "./events-carousel.vue?vue&type=style&index=0&id=29fa1b59&scoped=true&lang=css"

import exportComponent from "/home/rowen/www/html/catholic-club-fleet-base/themes/default/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29fa1b59"]])

export default __exports__